import { render, staticRenderFns } from "./PowerProfile.vue?vue&type=template&id=265902b4&scoped=true&"
import script from "./PowerProfile.vue?vue&type=script&lang=js&"
export * from "./PowerProfile.vue?vue&type=script&lang=js&"
import style0 from "./PowerProfile.vue?vue&type=style&index=0&id=265902b4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265902b4",
  null
  
)

export default component.exports